import React from 'react'
import Head from 'next/head'
import { CreateAIDesign } from '../../components/CreateAIDesign'

const AIDesignPage = () => {
  return (
    <>
      <Head>
        <title>AI Design Generation – DecorMatters</title>
        <meta name="description" content="Generate stunning interior designs with AI" />
      </Head>
      <CreateAIDesign />
    </>
  )
}

export default AIDesignPage
